import React from 'react'
import _ from 'lodash/fp'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { actions as authActions } from '../../../reducers/auth'

import GoogleLogin from 'react-google-login'

import Button from './Button'

import apolloClient from '../../../apollo'
import { useMutation } from 'react-apollo'
import { loader } from 'graphql.macro'
const continueWithAuthMutation = loader('../continueWithAuth.gql')

const GoogleLoginBase = props => {
  const [authenticate] = useMutation(continueWithAuthMutation, { client: apolloClient })
  const handleSuccess = async resp => {
    const token = _.get('accessToken', resp)
    const { data: { continueWithAuth } } = await authenticate({ variables: { provider: 'GOOGLE', token } })
    if (continueWithAuth.isNewUser) {
      const { name, email, clubId, clubName } = continueWithAuth
      props.history.replace('/signup', {
        userProfile: _.omitBy(_.isNil, { // Drop nulls and undefineds as validator.js can't handle NULL
          name,
          email,
          clubId,
          clubName
        }),
        cameFromSocialSignup: true,
        socialSignupOutput: continueWithAuth
      })
    } else {
      const {
        id: email,
        otp: password,
        provider
      } = continueWithAuth
      props.doLogin({ email, password, provider })
    }
  }

  const handleFailure = fail => console.warn('Unable to use Google sign in:', fail)

  return (
    <GoogleLogin
      clientId='20806497572-s2kr5s8m78jfdo416ilgbmd5t21h9hk3.apps.googleusercontent.com'
      onSuccess={handleSuccess}
      onFailure={handleFailure}
      cookiePolicy='single_host_origin'
      render={({ onClick }) => (
        <Button
          onClick={onClick}
          buttonColor='#4285F4'
          icon={<img style={{ height: 24 }} src={`/static/media/google.svg`} />}
        >
          Continue with Google
        </Button>
      )}
    />
  )
}

export default _.compose(
  connect(() => ({}), ({
    doLogin: authActions.loginRequest
  })),
  withRouter
)(GoogleLoginBase)
